

<button mat-raised-button (click)="getConditionIDsForCategory()">Get Condition IDs for Category</button>
<br><br>
<button mat-raised-button (click)="itemSpecifics()">Get Item Specifics</button>
<br><br>
<button mat-raised-button (click)="test()">Test Ebay Connection</button>

<!-- 
<div class="search" *ngFor="let item of search">
    <div>{{item.title}}</div>
    <div>{{item.currentBidPrice.value}}</div>
    <div><a [href]="item.itemWebUrl">Link</a></div>
</div> -->